import { PrintTemplate } from '../components/OCRImport/types'

export function sortPrintTemplateDetails(
  products: number[],
  data: PrintTemplate,
  printTemplateId: number | string | null
) {
  if (
    !Array.isArray(products) ||
    typeof data !== 'object' ||
    !Array.isArray(data.print_template_detail) ||
    data.id !== printTemplateId
  ) {
    return data // Handle invalid input or mismatched IDs
  }

  const productOrder: { [key: number]: number } = {}
  products.forEach((productId, index) => {
    productOrder[productId] = index
  })

  data.print_template_detail.sort((a, b) => {
    const productIdA = a.product?.id
    const productIdB = b.product?.id

    const indexA =
      productIdA !== undefined && productOrder[productIdA] !== undefined
        ? productOrder[productIdA]
        : Infinity
    const indexB =
      productIdB !== undefined && productOrder[productIdB] !== undefined
        ? productOrder[productIdB]
        : Infinity

    return indexA - indexB
  })

  return data
}
